import Immutable from 'immutable';
import { createSelector } from 'reselect';

import {
  selectAvailabilityEntities,
  selectBibItemEntities,
  selectLibraryEntities,
  selectSubscriptionEntities,
  selectHoldingEntities
} from '../EntitiesSelector';

const getAvailability = state => state.getIn(['bibs', 'availability'], Immutable.Map());

export const selectAvailabilityError = createSelector([getAvailability], availability =>
  availability.get('errorClassification')
);

export const selectBibItemsForCurrentBib = createSelector(
  [getAvailability, selectBibItemEntities],
  (availability, bibItemEntities) => availability.get('items', Immutable.List()).map(id => bibItemEntities.get(id))
);

export const selectSubscriptionsForCurrentBib = createSelector(
  [getAvailability, selectSubscriptionEntities],
  (availability, subscriptionEntities) =>
    availability.get('subscriptions', Immutable.List()).map(id => subscriptionEntities.get(id.toString()))
);

export const selectHoldingsForCurrentBib = createSelector(
  [getAvailability, selectHoldingEntities],
  (availability, holdingEntities) =>
    availability.get('holdings', Immutable.List()).map(id => holdingEntities.get(id.toString()))
);

export const selectProbesForCurrentBib = createSelector(
  [getAvailability, selectAvailabilityEntities, selectLibraryEntities],
  (availability, availabilities, libraries) => {
    return availability.get('probes', Immutable.List()).map(probe => {
      const libraryId = probe.get('libraryId');
      const metadataId = probe.get('metadataId');
      const library = libraries.get(String(libraryId), Immutable.Map());
      const probeAvailability = availabilities.get(metadataId, Immutable.Map());

      return probe.set('availability', probeAvailability).set('library', library);
    });
  }
);

export const selectAvailabilityProbes = createSelector([getAvailability], availability => availability.get('probes'));
